import { z } from 'zod';

export const SkillTypeEnum = z.enum(['SKILLS', 'KNOWLEDGE']);
export type SkillTypeEnumT = z.infer<typeof SkillTypeEnum>;
